import React from 'react';
import {useNavigate} from "react-router-dom";

const EmptyCourseList = () => {
    const navigate = useNavigate()
    return (
        <div className="card w-full bg-neutral mb-5 text-neutral-content">
            <div className="card-body p-5">
                <h2 className="card-title">Вы ещё не записались на курсы!</h2>
                <p>Узнать какие есть курсы для обучения можно нажав на кнопку ниже</p>
                <div className="card-actions justify-end">
                    <a href="https://codybara.ru/" className="btn btn-primary text-neutral-content">Посмотреть курсы</a>
                </div>
            </div>
        </div>
    );
};

export default EmptyCourseList;